import React, { useMemo } from 'react';
import { View, StyleSheet } from 'react-native';
import { Icon as KIcon, } from '@ui-kitten/components';
import styled from "../../../theming/util/styled";
import util from "../../util";
const S = StyleSheet.create({
    zeroPadding: {
        padding: 0,
        paddingTop: 0,
        paddingBottom: 0,
        paddingLeft: 0,
        paddingVertical: 0,
        paddingHorizontal: 0,
    },
    zeroMargin: {
        margin: 0,
        marginTop: 0,
        marginBottom: 0,
        marginLeft: 0,
        marginVertical: 0,
        marginHorizontal: 0,
    },
});
const DNAIcon = ({ testID, ...props }) => (<View testID={testID}>
    <KIcon {...props}/>
  </View>);
function parseThemeStyle(source, colorMode) {
    const { iconWidth, iconHeight, iconTintColor, iconTintColorDark, ...buttonContainer } = source;
    return {
        buttonContainer,
        icon: {
            width: iconWidth,
            height: iconHeight,
            color: colorMode !== 'dark' ? iconTintColor : iconTintColorDark,
        },
    };
}
const DNAIconStyled = (props) => {
    const { eva, color, CustomIcon, width, height, viewBox, testID, colorMode, name, ...rest } = props;
    const { icon } = parseThemeStyle(eva?.style, colorMode);
    const finalStyle = useMemo(() => util.mergeStyles(props, icon, {
        width: width ?? icon.width,
        height: height ?? icon.height,
        color: color ?? icon.color,
    }, S.zeroPadding, S.zeroMargin), [props, icon.width, icon.height, icon.color, width, height, color]);
    if (CustomIcon) {
        return (<CustomIcon data-testid={testID} // testID is a valid RN prop, but RNWeb may not yet convert it to be DOM friendly
         width={width ?? icon.width} height={height ?? icon.height} color={color ?? icon.color}/>);
    }
    return (<View testID={`icon-${name}${testID ? `-${testID}` : ''}`}>
      <KIcon {...rest} name={name} style={finalStyle}/>
    </View>);
};
const StyledDNAIcon = styled('Button')(DNAIconStyled);
const DNAIconStyledWrapper = (props) => {
    const defaultAppearance = props.appearance ?? 'outline';
    return (<StyledDNAIcon {...props} appearance={defaultAppearance}/>);
};
DNAIcon.displayName = 'DNAIcon';
DNAIconStyled.displayName = 'DNAIconStyled';
DNAIcon.Styled = DNAIconStyledWrapper;
export default DNAIcon;
//# sourceMappingURL=DNAIcon.js.map